import forOwn from 'mout/object/forOwn'

export default function findRecord(recordId, records) {
  let record = null
  if (recordId) {
    forOwn(records, function findMatchingGroup(groups, collection) {
      if (groups && groups[recordId]) {
        record = groups[recordId]
      }
    }) 
  }
  return record
}


// WEBPACK FOOTER //
// ./src/helpers/users/manageUsers/findRecord.js